var Abstract = require('./abstract');

require('./line');

module.exports = Abstract;